var EHDI = EHDI || Object.create(null);
var CKM = CKM || Object.create(null);


EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);
EHDI.scene.GameScene.prototype.initProps = function() {
}
EHDI.scene.GameScene.prototype.initGraphics = function() {
    //EHDI.GAME.gameScene = this;
    EHDI.scene.GameScene.game = new CKM.GameEngine();

    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
        if(EHDI.GAME.constants.customTimeLimit) {
            EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.customTimeLimit / 1000;
        } else {
            EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
        }
        EHDI.scene.GameScene.timer.x =  280;
        EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
   

    EHDI.scene.GameScene.shuffleBtn = new EHDI.displays.Button(EHDI.Assets.images["cm_ui_shufflebtn"], EHDI.Assets.images["cm_ui_shufflebtn_pressed"], null, null);
    EHDI.scene.GameScene.shuffleTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_SHUFFLE"));
    
    
    var _shuffleButtonClicked = function()
    {
        EHDI.GAME.soundManager.playSFX("button_sfx");
        EHDI.scene.GameScene.game.shuffleTray(true);
    }

    EHDI.scene.GameScene.shuffleBtn.setOnClickFunction(_shuffleButtonClicked);
    

    EHDI.scene.GameScene.multiplier = new EHDI.aka.Sprite(EHDI.Assets.images["cm_ui_x5"]);
    EHDI.scene.GameScene.multiplier.x = 215;
    EHDI.scene.GameScene.multiplier.y = 37.5;
    EHDI.scene.GameScene.multiplier.visible = false;

    
    EHDI.scene.GameScene.game.init();
    this.addChild(EHDI.scene.GameScene.game);

    EHDI.scene.GameScene.scoreHolder = EHDI.components.ScoreManager(this);
        EHDI.scene.GameScene.scoreHolder.setXY(10,5);
    this.addChild( EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);
    this.addChild(this.closeBtn);
    this.addChild(EHDI.scene.GameScene.multiplier);
    
    EHDI.scene.GameScene.shuffleTxt.anchor.set(0.5, 0.5);    
    EHDI.scene.GameScene.shuffleBtn.addChild(EHDI.scene.GameScene.shuffleTxt);
    EHDI.scene.GameScene.shuffleBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.75, EHDI.GAME.sceneManager.getStageHeight() * 0.075);    
    this.addChild(EHDI.scene.GameScene.shuffleBtn);

}

EHDI.scene.GameScene.prototype.initListeners = function() {
    EHDI.GAME.soundManager.autoResumeToggle(false);
}

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    //this.initProps();
    this.initGraphics();
    this.initListeners();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function() {
      
      EHDI.scene.GameScene.game.gameStart();  
    // var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    if(cache.isFirstTimePlay )
    {    
        cache.isFirstTimePlay = false;   
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
  
};

EHDI.scene.GameScene.prototype.killGraphics = function() {


    
    
    EHDI.scene.GameScene.shuffleBtn.destroy();
    EHDI.scene.GameScene.shuffleBtn = null;
    
    EHDI.scene.GameScene.shuffleTxt.destroy();
    EHDI.scene.GameScene.shuffleTxt = null;

    EHDI.scene.GameScene.multiplier.destroy();
    EHDI.scene.GameScene.multiplier = null;

    
    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer.destroy();
    EHDI.scene.GameScene.timer = null;
        
    EHDI.GAME.pauseButton.destroy();
    EHDI.GAME.pauseButton = null;

    if(this.closeBtn != null)
        {
            this.removeChild(this.closeBtn);
            this.closeBtn.dispose();
        }
      delete this.closeBtn;

      if(this.scoreHolder != null)
    {   
        this.scoreHolder.dispose();
    }
    delete this.scoreHolder;

   EHDI.scene.GameScene.timer.dispose();

     EHDI.scene.GameScene.game.init();

}

EHDI.scene.GameScene.prototype.dispose = function() {
    this.killGraphics();
}

EHDI.scene.GameScene.prototype.restart = function() {
    this.killGraphics();

    this.initProps();
    this.initGraphics();
    this.initListeners();
}

EHDI.scene.GameScene.prototype.replay = function() {
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.GameScene(), {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25});
 
}

EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    //this.destroy({children: true});
    
    delete this;
}

